import { Page } from "@/components/Page";
import { PageHero } from "@/components/PageHero";
import { HomeVisit } from "@/components/home/HomeVisit";
import { WhyChoose } from "@/components/WhyChoose";
import { AppointmentSection } from "@/components/AppointmentSection";
import { CLINIC_PHOTOS } from "@/data/site";

export default function HomeVisits() {
  return (
    <Page>
      <PageHero
        crumb="Home Visits"
        overline="Home Visit Physiotherapy"
        title={"Physiotherapy at\nYour Doorstep"}
        subtitle="Home visit physiotherapy in Belpahar & the Jharsuguda area — professional rehabilitation care in the comfort of your home."
        image={CLINIC_PHOTOS.homeVisit}
      />
      <HomeVisit />
      <WhyChoose />
      <AppointmentSection />
    </Page>
  );
}
